import React from 'react';
import { useTranslation } from 'react-i18next';

const UserInfoTableNotice = (): React.ReactElement => {
  const { t } = useTranslation();
  // SIDE EFFECT
  // ================================================================================

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <div id="userInfoTableNotice">
        <p>
          <i className="material-icons">account_circle</i>
          {t('user.message')}
        </p>
      </div>
    </>
  );
};

export default UserInfoTableNotice;
